<template>
   
    <div class="agreement-confirm-main-box"  v-if="flag">
        <div class="agreement-confirm-box">
            <div class="top">
                <div class="title">用户协议及隐私保护</div>
                <div class="content">
                       <span class="tip">我已同意并阅读</span>
                    <span v-for="(item, index) in agree" :key="index">
                        <span class="tip" @click="change(item)">
                            {{ item.name }}
                        </span>
                    </span>
                    <span style="color: #666;">
                        等内容
                    </span>
                </div>
                <van-divider />
                <div class="mobile">
                    {{ mobile }}
                </div>
                <div class="titlie1">
                    办理权益手机号
                </div>
            </div>
            <div class="bottomss">
                <div class="cancel-btn1" @click="cflag">拒绝</div>
                <div class="submit-btn1" @click="sure">同意</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Alisure",
    data() {
        return {

        };
    },
    methods: {
       
           change(e) {
      console.log(e)
      if (e.url) {
        window.location.href = e.url
      } else {
        console.log(e.id)
        if (e.id == 1) {
          this.$emit('ys', true)
        }
        else if (e.id == 3) {
          this.$emit('rule', true)
        }
      }
     
    },
        sure() {
            this.$emit('sure', false)
        },
        cflag() {
            this.$emit('cflag', false)
        }
    },
    props: {
        flag: Boolean,
        agree: Array,
        env: String,
        mobile: String,
    },
};
</script>

<style scoped>
.agreement-confirm-main-box {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background: url("https://qiming-1308147483.cos.ap-chengdu.myqcloud.com/doc%2Fpinzhi_shenghuo_huiyuan_quanyi%2Fcommon%2Flogin-shadow-bg.png") repeat;
    z-index: 3;
    /* 遮罩层渐显动画 */
    animation: maskFadeIn 0.3s ease-out forwards;
    opacity: 0; /* 初始透明 */
}

.agreement-confirm-box {
    position: fixed;
    bottom: 0;
    border-radius: 20px 20px 0 0;
    background-color: #fff;
    padding: 15px;
    width: 100%;
    box-sizing: border-box;
    /* 核心：弹窗滑入动画 */
    transform: translateY(100%); /* 初始在视口外（底部） */
    opacity: 0; /* 初始透明 */
    animation: slideUp 0.3s ease-out forwards; /* 动画：0.3秒滑入 + 缓出 */
    animation-delay: 0.05s; /* 轻微延迟，更自然 */
}

/* 遮罩层渐显动画 */
@keyframes maskFadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

/* 弹窗从底部滑入 + 渐显动画 */
@keyframes slideUp {
    from {
        transform: translateY(100%);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
}

.agreement-confirm-box .title {
    font-size: 14px;
    color: #000000;
    text-align: left;
    font-weight: 400;
    padding-left: 2px;
}

.agreement-confirm-box .mobile {
    text-align: left;
    font-size: 13px;
}

.agreement-confirm-box .titlie1 {
    color: #A5A5A5;
    font-size: 12px;
    margin-top: 2px;
    margin-left: 2px;
    text-align: left;
}

.agreement-confirm-box .content {
    font-size: 11px;
    color: #000000;
    text-align: justify;
    margin-top: 20px;
    flex-wrap: wrap;
    .tip {
        color: #666;
    }
}

.agreement-confirm-box .top {
    padding: 4px 12px;
}

.agreement-confirm-box .bottomss {
    display: flex;
    padding: 20px 0;
    justify-content: space-around;
    align-items: center;
}

 .submit-btn1 {
    width: 162px;
    height: 50px;
    background: #1777FF;
    border-radius: 5px;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    /* 按钮轻微hover效果（可选） */
    transition: background 0.2s ease;
}


.cancel-btn1{
    width: 162px;
    height: 50px;
    background: #FFFFFF;
    border-radius: 5px;
    border: 1px solid #CCCCCC;
    display: flex;
    justify-content: center;
    align-items: center;
    /* 按钮轻微hover效果（可选） */
    transition: border-color 0.2s ease;
}
</style>